import React, { useState, useMemo, useEffect } from 'react';
import styles from './styles.module.scss';
import CreatePopUpPortal from '../../utility/CreatePopUpPortal';
import ShieldIcon from '../../icons/ShieldIcon';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { getApiNHL } from '../../config/environment';

const DwallPopup = props => {
    const [showPopUp, setShowPopUp] = useState(false);
    const [popupMode, setPopupMode] = useState(0);
    const [timers, setTimers] = useState(0);
    const {
        live_clock = "20:00",
        gameID = "",
        live_teamD = {},
        setNhlEventData=[]
    } = useSelector(state => state.nhl);
    // console.log("props.data===>",props.data);
    const userID = localStorage.getItem("PERSONA_USER_ID");
    const applyDWall = async () => {
        let eventdata;
        let eventData1= Object.keys(setNhlEventData).map((item, i) => {
            if(item===props?.data?.match?.id){
              if(setNhlEventData[item]?.length!==0){
                let liveClockData =  setNhlEventData[item].filter(x => x?.id  == props?.data?.match?.id);
                if(liveClockData?.length > 0 )
                {
                    eventdata= liveClockData[liveClockData?.length-1];
                }
              }
            }
          })
        props.setShowPleaseWait(true);
        var a = await axios.post(`${getApiNHL()}/api/v1/services/fantasy/dWallApplied`, {
            gameID: props?.data?.gameID,
            userID: props?.data?.userID,
            timeApplied: eventdata?.clock?eventdata?.clock:"20:00",
            // teamDId:live_teamD?.id,
            teamDId:props?.data?.id,
            period:eventdata?.period?eventdata?.period:1,
        })
        .then((res) => {
            if(res.data.code == 200)
            {
                // props.useDwall(true,props.data);
                // props.setDWellGState()
                props.setIsDwallActive(true);
                setShowPopUp(false);
                props.setShowPleaseWait(false);
            }
            else {
                props.setShowPleaseWait(false);
                alert(res.data.message);
                setShowPopUp(false);
            }
        })
        .catch((er) => {
            props.setShowPleaseWait(false);
            alert(er.response?.data?.message);
            setShowPopUp(false);
        });
    };
    return (
        <>
            {useMemo(() => props.component && props.component({ showPopUp: () => { setPopupMode(0);setShowPopUp(true); }}), [props])}
            {showPopUp && <CreatePopUpPortal>
                <div className={styles.popupWrapper}>
                    <div className={styles.blur} onClick={() => setShowPopUp(false)}></div>
                    <div className={styles.popupInnerDiv}>
                        <div className={`__title-6 modal-animation ${styles.popup}`}>
                            <>
                                <ShieldIcon size={100} />
                                <p>
                                    Use your <span className="orangeColor">D-Wall Power</span> to block any points against your Team D for this inning.
                                </p>
                                <div>
                                    <button className={styles.cancelButton} onClick={() => {
                                        setShowPopUp(false);
                                    }}>Cancel</button>
                                    <button className={styles.challengePlayButton} onClick={() => {
                                        if(props.dwall > 0)
                                        {
                                            applyDWall();
                                        }
                                        else {
                                            alert("You cannot use D-Wall power");
                                        }
                                    }}>Activate D-Wall</button>
                                </div>
                            </>
                        </div>
                    </div>
                </div>   
            </CreatePopUpPortal>}
        </>
    );
};

export default DwallPopup;